module.exports = __webpack_public_path__ + "static/media/22.35fc46c5.png";